import React  from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../app/auth/authSlice";
import { useNavigate, Link } from "react-router-dom";
 
function DropdownProfile() {
  const user = useSelector((state) => state.auth.user);
  const firstName = user?.userData?.firstName || "";
  const lastName = user?.userData?.lastName || "";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const Logout = () => {
    dispatch(logout());
    setTimeout(() => {
      navigate("/user/login", { replace: true });
    }, 0);
  };
 

  return (
    <div className="navbar-item navbar-user dropdown">
      <a
        href="#/"
        className="navbar-link dropdown-toggle d-flex align-items-center"
        data-bs-toggle="dropdown"
      >
        <div className="image image-icon bg-gray-800 text-gray-600">
          <i className="fa fa-user"></i>
        </div>
        <span>
          <span className="d-none d-md-inline">
            {firstName} {lastName}
          </span>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end me-1">
        <Link to="/profile" className="dropdown-item">
          Profile
        </Link>
        {/* <a href="#/" className="dropdown-item d-flex align-items-center">
          Inbox
          <span className="badge bg-danger rounded-pill ms-auto pb-4px">2</span>
        </a>
        <a href="#/" className="dropdown-item">
          Calendar
        </a>
        <a href="#/" className="dropdown-item">
          Settings
        </a> */}
        <div className="dropdown-divider"></div>
        <span onClick={Logout} className="dropdown-item">
          Log Out
        </span>
      </div>
    </div>
  );
}

export default DropdownProfile;
